/**
 * Tool Progress Component
 *
 * Displays multi-step progress for long-running tools.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle, Circle, Loader2 } from 'lucide-react';
export function ToolProgress({ steps, progressState }) {
    if (!progressState || !steps.length) {
        return null;
    }
    // Use Math.max to ensure we have a valid index even if step ID isn't found
    const currentStepIndex = Math.max(0, steps.findIndex((s)=>s.id === progressState.currentStep));
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "h-1 bg-background/50 rounded-full overflow-hidden",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "h-full bg-current opacity-50 transition-all duration-300 ease-in-out",
                    style: {
                        width: `${progressState.progress}%`
                    }
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center gap-1 text-xs overflow-x-auto pb-1",
                children: steps.map((step, index)=>{
                    const isCompleted = index < currentStepIndex;
                    const isCurrent = index === currentStepIndex;
                    const isPending = index > currentStepIndex;
                    return /*#__PURE__*/ _jsxs("div", {
                        className: `flex items-center gap-1 whitespace-nowrap ${isPending ? 'opacity-50' : ''}`,
                        children: [
                            isCompleted && /*#__PURE__*/ _jsx(CheckCircle, {
                                className: "h-3 w-3 flex-shrink-0"
                            }),
                            isCurrent && /*#__PURE__*/ _jsx(Loader2, {
                                className: "h-3 w-3 animate-spin flex-shrink-0"
                            }),
                            isPending && /*#__PURE__*/ _jsx(Circle, {
                                className: "h-3 w-3 flex-shrink-0"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: isCurrent ? 'font-medium' : '',
                                children: step.label
                            }),
                            index < steps.length - 1 && /*#__PURE__*/ _jsx("span", {
                                className: "opacity-50 mx-1",
                                children: "→"
                            })
                        ]
                    }, step.id);
                })
            }),
            progressState.details && /*#__PURE__*/ _jsx("div", {
                className: "text-xs opacity-70",
                children: progressState.details
            })
        ]
    });
}
